import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            GET /users/{"{"}userId{"}"}/people <b>DEPRECATED</b>
          </h1>
        </div>
        <p>
          Return a JSON object that lists users that are in the same company as{" "}
          {"{"}userId{"}"}. Results can be filtered using the search parameter.
          Note: Only the top 5 results are returned.
        </p>
        <h2>URL Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Location</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>userId</td>
                <td>Unique identifier of the user performing the search.</td>
                <td>path</td>
                <td>Yes</td>
                <td />
              </tr>
              <tr>
                <td>search</td>
                <td>Regular expression to filter results.</td>
                <td>query</td>
                <td>No</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Body Parameters</h2>
        <p>None.</p>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          GET https://spacesapis.avayacloud.com/api/users/{"{"}userId{"}"}/people
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          [{"\n"}
          {"  "}
          {"{"}
          {"\n"}
          {"    "}"_id": "5846cc603bab0e18ff03cca0",{"\n"}
          {"    "}"displayname": "ericd ding",{"\n"}
          {"    "}"picturefile":
          "pictures/pfpic_ericd_7f5a14d1-60e3-47c0-a8f9-dd042c7fb05a",{"\n"}
          {"    "}"picture_url":
          "https://storage.googleapis.com/onesna/pictures/pfpic_ericd_7f5a14d1-60e3-47c0-a8f9-dd042c7fb05a",
          {"\n"}
          {"    "}"name": {"{"}
          {"\n"}
          {"      "}"pronunciation_url": "",{"\n"}
          {"      "}"pronunciation": "",{"\n"}
          {"      "}"middlename": "",{"\n"}
          {"      "}"honorific_suffix": "",{"\n"}
          {"      "}"honorific_prefix": "",{"\n"}
          {"      "}"givenname": "ericd",{"\n"}
          {"      "}"formatted": "",{"\n"}
          {"      "}"familyname": "ding"{"\n"}
          {"    "}
          {"}"},{"\n"}
          {"    "}"username": "ericd@esna.com"{"\n"}
          {"  "}
          {"}"}
          {"\n"}]{"\n"}
        </pre>
      </div>
    </div>
  </Layout>
)
